export default "__VITE_ASSET__BBzRSF8T__"